import { SortableCue } from './sortable-cue'
import type { FC } from 'react'
import { Cue } from '../../cue/ui/cue'

type DraggableCueProps = {
  cueId: string
}

export const DraggableCue: FC<DraggableCueProps> = ({ cueId }) => {
  return (
    <SortableCue cueId={cueId}>
      <Cue cueId={cueId} />
    </SortableCue>
  )
}
